// Time zones for the Scheduled Reports editor. Each Intl feature is detected on its own: the browser's
// zone list when it has one, otherwise a short list; each label built in its own try/catch, so a zone the
// browser rejects is dropped from the list and a stored one is shown by name only.
const COMMON_ZONES = [
  "UTC",
  "Africa/Cairo",
  "Africa/Johannesburg",
  "Africa/Lagos",
  "America/Chicago",
  "America/Denver",
  "America/Grenada",
  "America/Los_Angeles",
  "America/New_York",
  "America/Sao_Paulo",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Riyadh",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/London",
  "Europe/Paris",
  "Pacific/Auckland",
];

export function browserZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
}

// "GMT+05:00" where the browser knows longOffset, otherwise its short name ("GMT+5", "PKT").
export function zoneOffset(zone, at = new Date()) {
  for (const timeZoneName of ["longOffset", "short"]) {
    try {
      const parts = new Intl.DateTimeFormat("en-GB", { timeZone: zone, timeZoneName }).formatToParts(at);
      const part = parts.find((p) => p.type === "timeZoneName");
      if (part) return part.value;
    } catch (e) {
      // this browser lacks the style or the zone: try the next style
    }
  }
  return "";
}

export function zoneLabel(zone, at) {
  const offset = zoneOffset(zone, at);
  return offset ? `${zone} (${offset})` : zone;
}

// [{ value, label }] for the zone select, UTC always among them.
export function timeZoneOptions(at) {
  let zones;
  try {
    zones = Intl.supportedValuesOf("timeZone");
  } catch (e) {
    zones = COMMON_ZONES;
  }
  const all = zones.includes("UTC") ? zones : ["UTC", ...zones];
  return all.filter((zone) => zoneOffset(zone, at)).map((zone) => ({ value: zone, label: zoneLabel(zone, at) }));
}
